import React, { useState, useRef } from 'react';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { About } from './components/About';
import { HowItWorks } from './components/HowItWorks';
import { Legal } from './components/Legal';
import { ConsultationForm } from './components/ConsultationForm';
import { FAQ } from './components/FAQ';
import { Footer } from './components/Footer';
import { CherryButton } from './components/CherryButton';
export type Language = 'en' | 'es';
export function App() {
  const [language, setLanguage] = useState<Language>('en');
  const formRef = useRef<HTMLDivElement>(null);
  const scrollToForm = () => {
    formRef.current?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <>
      <div className="w-full min-h-screen bg-gradient-to-b from-espresso via-brown-dark to-[#0f0906]" data-id="element-0">
        <Navbar language={language} setLanguage={setLanguage} data-id="element-1" />
        <Hero language={language} scrollToForm={scrollToForm} data-id="element-2" />
        <About language={language} data-id="element-3" />
        <HowItWorks language={language} data-id="element-4" />
        <Legal language={language} data-id="element-5" />
        <div ref={formRef} data-id="element-6">
          <ConsultationForm language={language} data-id="element-7" />
        </div>
        <FAQ language={language} data-id="element-8" />
        <Footer language={language} data-id="element-9" />
      </div>
      <CherryButton language={language} data-id="element-10" />
    </>;
}